import { Navigate, useLocation } from "react-router-dom";

/**
 * Legacy invite URL compatibility. Password set lives at `/set-password`;
 * preserve query params (token, invite_source, etc.).
 */
export function InviteAcceptPage() {
  const location = useLocation();
  return <Navigate to={`/set-password${location.search}`} replace />;
}
